<template>
    <myhead  :value="value" @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
    <div class="msgcontainer">
        <ForumList></ForumList>
    </div>
    <WsTabbar v-if="$route.path.includes('/shop')"></WsTabbar>
</template>
<script setup>
import ForumList from "./components/forumNotify/list.vue";
import {nextFn} from "@/utils/type.js";
//右箭头
const next = () => {
    nextFn()
}

</script>
<style scoped>
.msgcontainer {
    background: #F6F6F6;
    height: 100vh;
    padding-top: 5px;
}
</style>